import {
  EventEditScope,
  EventStatus,
  EVENT_EDIT_SCOPE_DISPLAY,
  EVENT_STATUS_DISPLAY,
} from "@mimber/schema"

export const SCOPE_OPTIONS = (
  Object.entries(EVENT_EDIT_SCOPE_DISPLAY) as [
    EventEditScope,
    { label: string; description: string },
  ][]
).map(([value, { label, description }]) => ({ value, label, description }))

export const STATUS_OPTIONS = (
  Object.entries(EVENT_STATUS_DISPLAY) as [
    EventStatus,
    { label: string; color: string },
  ][]
).map(([value, { label }]) => ({ value, label }))
